export interface AtlasError {
	apiVersion: string;
	atlasErrorId: string;
	details?: string;
	documentationUrl: string;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export function isAtlasError(error: any): error is AtlasError {
	return typeof error === "object" && "atlasErrorId" in error;
}
